// extracted by mini-css-extract-plugin
export default {"logo":"qba","cancel":"rba","stickyheader":"sba","buttonswrap":"tba","item":"uba","starterKit":"vba","boldHeader":"wba","reviewheader":"xba","text":"yba","username":"zba"};
    if(module.hot) {
      // 1738064244349
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  